// extracted by mini-css-extract-plugin
export default {"chatBox":"ClientJR_chatBox__6SUm2","hover":"ClientJR_hover__Rf8N6"};